import type {AskHealthVersion} from 'client';

/** The two offline rubric judges (Opus, gpt-6.1-sol) averaged, 0–100. */
export const offlineQuality = (v: AskHealthVersion): number | null => {
  const scores = [v.opus, v.gpt61].filter((s): s is number => s != null);
  return scores.length ? (100 * scores.reduce((a, b) => a + b, 0)) / scores.length : null;
};

/** The earlier version with the extreme value of `pick`, for "was X on <date>". */
export const extremeBefore = (
  versions: AskHealthVersion[],
  pick: (v: AskHealthVersion) => number | null | undefined,
  worst: 'min' | 'max'
): AskHealthVersion | undefined =>
  versions.slice(0, -1).reduce<AskHealthVersion | undefined>((best, v) => {
    const value = pick(v);
    if (value == null) {
      return best;
    }
    const bestValue = best ? pick(best) : null;
    if (bestValue == null) {
      return v;
    }
    return (worst === 'min' ? value < bestValue : value > bestValue) ? v : best;
  }, undefined);
